<template>
  <div>
    <md-card class="picture-card">
      <md-subheader>
        {{$t("games.photos.title")}}
        <md-button class="md-simple" @click="getImages()"><md-icon>refresh</md-icon> Refresh</md-button>  
      </md-subheader>
      <md-card-media-actions class="picture-card-container">
        <md-card-container>
          <div class="none-image" v-if="dataPicture.picture == undefined"></div>
          <template v-else>
            <badge type="info" class="badge-name" v-if="getNameImage(dataPicture.picture) != ''">{{getNameImage(dataPicture.picture)}}</badge>
            <img :src="getUrlImage(dataPicture.picture)" alt="">
          </template>
        </md-card-container>

        <md-card-actions>
          <md-button class=" md-success" :disabled="dataPicture.picture == undefined" @click="approve(dataPicture.id)">
            <md-icon>check</md-icon>
          </md-button>

          <md-button class=" md-danger" :disabled="dataPicture.picture == undefined" @click="reject(dataPicture.id)">
            <md-icon>close</md-icon>
          </md-button>
        </md-card-actions>
      </md-card-media-actions>
    </md-card>
    <md-button class="md-success md-block download-button" @click="goToDownloadImages()">Descarga las imagenes aprobadas</md-button>
  </div>
</template>

<script>
import { Badge } from '@/components';

export default {
  props: {
    teamId: Number,
    gameId: Number
  },
  components: {
    Badge
  },
  data() {
    return {
      totalPictures: 0,
      dataPicture: {}
    }
  },
  async mounted() {
    this.getImages()
  },
  methods: {
    async getImages () {
      const params = {
        gameId: this.gameId,
        teamId: this.teamId
      }
      const request = await this.$store.dispatch("getFanPicturePendingReview", params)
      this.totalPictures = request.data.totalResults
      this.dataPicture = request.data.data[0]
    },
    async approve(id) {
      this.dataPicture = {}
      const request = await this.$store.dispatch("approveFanPicture", {id})
      if (request!= undefined) {
        this.$notify({
          message: this.$t(`notifications.game.picture.approve`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.getImages()
      } else {
        this.$store.dispatch("openModalError")
      }
    },
    async reject(id) {
      this.dataPicture = {}
      const request = await this.$store.dispatch("rejectFanPicture", {id})
      if (request!= undefined) {
        this.$notify({
          message: this.$t(`notifications.game.picture.reject`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
        this.getImages()
      } else {
        this.$store.dispatch("openModalError")
      }
    },
    getUrlImage(path) {
      return `${process.env.VUE_APP_CDN_URL_FAN_PICTURES}${path}`
    },
    getNameImage(path) {
      const split = path.split("--")
      return split.length > 1 ? split[0].replace("-", " ") : ""
    },
    goToDownloadImages() {
      this.$router.push(`/game/pictures/${this.gameId}/${this.teamId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
  .picture-card {
    width: 100%;
    display: inline-block;
    vertical-align: top;
    border: 1px solid #bcbcbc;
    margin-bottom: 16px;
    box-sizing: border-box;

    &-container {
      display: flex;
      justify-content: space-around;
    }

    .md-card-actions {
      border-top: 0;
    }

    .md-subheader {
      display: flex;
      justify-content: space-between;
    }

    img, .none-image {
      object-fit: contain;
      height: 500px;
      width: 500px;
    }

    .none-image {
      background: rgba(0,0,0,.5);
    }

    md-card-container {
      position: relative;

      .badge-name {
        position: absolute;
        top: 8px;
      }
    }
  }
  .download-button {
    margin: 24px 0;
  }
</style>